interface SectionHeaderProps {
  label: string;
  title: string;
  description?: string;
  className?: string;
  id?: string;
}

export default function SectionHeader({
  label,
  title,
  description,
  className = "",
  id,
}: SectionHeaderProps) {
  return (
    <div className={`space-y-4 ${className}`}>
      <p className="text-xs uppercase tracking-[0.35em] text-blue-600 font-semibold">
        {label}
      </p>
      <h2 id={id} className="font-display text-3xl sm:text-4xl text-gray-900">
        {title}
      </h2>
      {description && (
        <p className="max-w-2xl text-base sm:text-lg text-gray-700 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}

